import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    GET_STATUS: '/v1/maintenance',
};

export interface MaintenanceStatus {
    maintenance: boolean;
    bypass?: boolean;
}

export function getMaintenanceStatus(): Promise<MaintenanceStatus> {
    return httpClient.get(ENDPOINTS.GET_STATUS);
}
